module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"auth-code":"Auth Code","failed-authorise":"Authorisation failed, please try again.","auth":"Authorise Order Source"}}')
  delete Component.options._Ctor
}
